/// <amd-module name="CodeCoverage/CodeCoverageCiTab/Services/CodeCoverageCiTabProviderService" />

import * as React from "react";

import { IVssContributableTabService } from "VSS/Features/Frame/IVssContributableTabService";
import { Services } from "VSS/Platform/Context";
import { IVssContributedPivotBarItem } from "VSSUI/Components/PivotBar/PivotBar.Props";

import { Build, BuildStatus } from "Build/Client/Contracts/Build";
import { IBuildResultsViewExtensionConfig } from "Build/Common/Library/ContributedExtension.types";
import { IRepoCodeCoverageProps, RepoCodeCoverage } from "CodeCoverage/CodeCoverageCiTab/Components/RepoCodeCoverage";

import * as Resources from "CodeCoverage/CodeCoverageCiTab/Resources";
import { CoverageTabProviderServiceBase } from "CodeCoverage/CodeCoverageCiTab/Services/CoverageTabProviderServiceBase";
import { TelemetryEvents } from "CodeCoverage/ViewCommon/Constants";
import { publish } from "CodeCoverage/ViewCommon/Helpers";
import { RunViewArtifact } from "CodeCoverage/ViewCommon/RunViewArtifact";

export class CodeCoverageCiTabProviderService extends CoverageTabProviderServiceBase implements IVssContributableTabService {
    private updateTabItemsHandle: (items: IVssContributedPivotBarItem[]) => void;
    private coverageTabEnabled: boolean = false;
    private cachedTab: IVssContributedPivotBarItem;

    public loadItems(updateItems: (items: IVssContributedPivotBarItem[]) => void, itemContext?: IBuildResultsViewExtensionConfig): void {
        if (itemContext) {
            itemContext.onBuildChanged((build: Build) => {
                if (build.status === BuildStatus.Completed && !this.coverageTabEnabled) {
                    this.coverageTabEnabled = true;

                    const runViewArtifact = RunViewArtifact.GetArtifactDataFromBuild(build);
                    this.updateTabItemsHandle = updateItems;

                    this.startFetchTab(runViewArtifact);
                } else if (this.coverageTabEnabled && this.cachedTab) {
                    // This step is required because platform/buildpage sometimes calls loadItems twice
                    // We want to avoid startFetchTab being called twice hence we cache the tab on the first reply

                    updateItems([this.cachedTab]);
                } else if (this.coverageTabEnabled) {
                    // if tab wasn't cached simply set updateTabItemsHandle to latest method
                    this.updateTabItemsHandle = updateItems;
                }
            });
        } else {
            console.error("itemContext should've been present.");
        }
    }

    protected initTab = (getTab: () => React.ComponentElement<IRepoCodeCoverageProps, RepoCodeCoverage>) => {
        this.cachedTab = {
            // Keeping this id same as old code coverage tab
            id: "codecoverage-tab",
            render: () => {
                return getTab();
            },
            text: Resources.CodeCoverageTabName,
            onBeforePivotChange: () => {
                publish(this.pageContext, TelemetryEvents.CodeCoverageCiTabClicked);
                return true;
            }
        };
        this.updateTabItemsHandle([this.cachedTab]);
    };
}

export let CodeCoverageCiTabProviderServiceName = "codecoverage-ci-tab-provider-service";

Services.add(CodeCoverageCiTabProviderServiceName, { serviceFactory: CodeCoverageCiTabProviderService });
